export default function PHP_preg_quote() {
  return (
    <div>
      <h1>PHP_preg_quote</h1>
    </div>
  );
}
